import React, { useState, useEffect } from 'react';
import './App.css';

const App = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const featuredDishes = [
    {
      image: "https://images.pexels.com/photos/32592735/pexels-photo-32592735.jpeg",
      title: "Manakish Za'atar - مناقيش زعتر",
      description: "Traditional Lebanese flatbread with za'atar and olive oil"
    },
    {
      image: "https://images.pexels.com/photos/28241705/pexels-photo-28241705.jpeg",
      title: "Mixed Mezze - مزة مشكلة",
      description: "Authentic Lebanese mezze platter with hummus, tabbouleh & more"
    },
    {
      image: "https://images.unsplash.com/photo-1635432877848-9c86755eb2f9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxMZWJhbmVzZSUyMGJyZWFrZmFzdHxlbnwwfHx8fDE3NTAzODk3MTl8MA&ixlib=rb-4.1.0&q=85",
      title: "Lebanese Breakfast - فطور لبناني",
      description: "Complete breakfast with olives, cheese, tomatoes & fresh bread"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % featuredDishes.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-red-50" style={{backgroundColor: '#F5F0E8'}}>
      {/* Navigation */}
      <nav className="fixed top-0 w-full z-50 backdrop-blur-lg shadow-xl" style={{backgroundColor: 'rgba(245, 240, 232, 0.95)', borderBottom: '3px solid #D4700A'}}>
        <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8">
          {/* Top decorative border */}
          <div className="h-1" style={{background: 'linear-gradient(90deg, #5D1A1A 0%, #D4700A 25%, #5D1A1A 50%, #D4700A 75%, #5D1A1A 100%)'}}></div>
          
          <div className="flex justify-between items-center h-16 sm:h-20">
            <div className="flex items-center space-x-2 sm:space-x-4">
              {/* Enhanced Logo - Responsive sizing */}
              <div className="relative z-10 text-center flex items-center justify-center">
                    <img 
                      src={process.env.PUBLIC_URL + '/logo.png'} 
                      alt="Byblos Logo" 
                      className="h-12 sm:h-16 w-auto mx-auto"
                      style={{ borderRadius: '10px' }}

                    />
                  </div> 
              
              {/* Restaurant Name with Arabic - Hidden on small screens */}
              <div className="hidden sm:flex flex-col">
                <div className="text-xl sm:text-2xl lg:text-3xl font-bold leading-tight" style={{color: '#5D1A1A', fontFamily: 'Inter, sans-serif'}}>
                  Byblos on O'Connell
                </div>
                <div className="text-xs sm:text-sm lg:text-lg font-arabic leading-none -mt-1" style={{color: '#D4700A', fontFamily: 'Amiri, serif'}}>
                  مطعم بيبلوس • North Adelaide
                </div>
              </div>
            </div>
            
            {/* Desktop Menu - Hidden on mobile/tablet */}
            <div className="hidden lg:flex items-center space-x-1">
              {/* Decorative separator */}
              <div className="w-px h-8 mx-4" style={{backgroundColor: '#D4700A'}}></div>
              
              <button onClick={() => scrollToSection('home')} className="px-3 py-2 rounded-lg transition-all duration-300 font-medium text-center group relative overflow-hidden">
                <span className="relative z-10" style={{color: '#5D1A1A'}}>
                  <span className="block text-sm font-arabic" style={{color: '#D4700A'}}>الرئيسية</span>
                  <span className="block text-xs">Home</span>
                </span>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-orange-100 to-transparent transform -translate-x-full group-hover:translate-x-full transition-transform duration-500"></div>
              </button>
              
              <button onClick={() => scrollToSection('breakfast')} className="px-3 py-2 rounded-lg transition-all duration-300 font-medium text-center group relative overflow-hidden">
                <span className="relative z-10" style={{color: '#5D1A1A'}}>
                  <span className="block text-sm font-arabic" style={{color: '#D4700A'}}>فطور</span>
                  <span className="block text-xs">Breakfast</span>
                </span>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-orange-100 to-transparent transform -translate-x-full group-hover:translate-x-full transition-transform duration-500"></div>
              </button>
              
              <button onClick={() => scrollToSection('dining')} className="px-3 py-2 rounded-lg transition-all duration-300 font-medium text-center group relative overflow-hidden">
                <span className="relative z-10" style={{color: '#5D1A1A'}}>
                  <span className="block text-sm font-arabic" style={{color: '#D4700A'}}>طعام</span>
                  <span className="block text-xs">Dining</span>
                </span>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-orange-100 to-transparent transform -translate-x-full group-hover:translate-x-full transition-transform duration-500"></div>
              </button>
              
              <button onClick={() => scrollToSection('gallery')} className="px-3 py-2 rounded-lg transition-all duration-300 font-medium text-center group relative overflow-hidden">
                <span className="relative z-10" style={{color: '#5D1A1A'}}>
                  <span className="block text-sm font-arabic" style={{color: '#D4700A'}}>معرض</span>
                  <span className="block text-xs">Gallery</span>
                </span>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-orange-100 to-transparent transform -translate-x-full group-hover:translate-x-full transition-transform duration-500"></div>
              </button>
              
              <button onClick={() => scrollToSection('events')} className="px-3 py-2 rounded-lg transition-all duration-300 font-medium text-center group relative overflow-hidden">
                <span className="relative z-10" style={{color: '#5D1A1A'}}>
                  <span className="block text-sm font-arabic" style={{color: '#D4700A'}}>مناسبات</span>
                  <span className="block text-xs">Events</span>
                </span>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-orange-100 to-transparent transform -translate-x-full group-hover:translate-x-full transition-transform duration-500"></div>
              </button>
              
              <button onClick={() => scrollToSection('catering')} className="px-3 py-2 rounded-lg transition-all duration-300 font-medium text-center group relative overflow-hidden">
                <span className="relative z-10" style={{color: '#5D1A1A'}}>
                  <span className="block text-sm font-arabic" style={{color: '#D4700A'}}>خدمة</span>
                  <span className="block text-xs">Catering</span>
                </span>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-orange-100 to-transparent transform -translate-x-full group-hover:translate-x-full transition-transform duration-500"></div>
              </button>
              
              <button onClick={() => scrollToSection('contact')} className="px-3 py-2 rounded-lg transition-all duration-300 font-medium text-center group relative overflow-hidden">
                <span className="relative z-10" style={{color: '#5D1A1A'}}>
                  <span className="block text-sm font-arabic" style={{color: '#D4700A'}}>اتصال</span>
                  <span className="block text-xs">Contact</span>
                </span>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-orange-100 to-transparent transform -translate-x-full group-hover:translate-x-full transition-transform duration-500"></div>
              </button>
              
              {/* Decorative separator */}
              <div className="w-px h-8 mx-4" style={{backgroundColor: '#D4700A'}}></div>
              
              {/* Call to Action Button */}
              <button 
                onClick={() => scrollToSection('contact')}
                className="px-4 py-2 rounded-full font-bold text-white shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 relative overflow-hidden group"
                style={{background: 'linear-gradient(135deg, #5D1A1A, #D4700A)'}}
              >
                <span className="relative z-10 text-sm">احجز الآن</span>
                <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent transform translate-x-full group-hover:translate-x-0 transition-transform duration-300"></div>
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <div className="w-6 h-6 flex flex-col justify-center space-y-1">
                <div className={`w-full h-0.5 transition-all ${isMenuOpen ? 'rotate-45 translate-y-1' : ''}`} style={{backgroundColor: '#5D1A1A'}}></div>
                <div className={`w-full h-0.5 transition-all ${isMenuOpen ? 'opacity-0' : ''}`} style={{backgroundColor: '#5D1A1A'}}></div>
                <div className={`w-full h-0.5 transition-all ${isMenuOpen ? '-rotate-45 -translate-y-1' : ''}`} style={{backgroundColor: '#5D1A1A'}}></div>
              </div>
            </button>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="lg:hidden border-t" style={{backgroundColor: 'rgba(245, 240, 232, 0.98)', borderColor: '#D4700A'}}>
              <div className="px-2 pt-2 pb-3 space-y-1">
                <button onClick={() => scrollToSection('home')} className="flex w-full text-left px-3 py-3 transition-colors rounded-lg">
                  <div className="flex-1">
                    <div className="font-arabic text-lg" style={{color: '#D4700A'}}>الرئيسية</div>
                    <div className="text-sm" style={{color: '#5D1A1A'}}>Home</div>
                  </div>
                </button>
                <button onClick={() => scrollToSection('breakfast')} className="flex w-full text-left px-3 py-3 transition-colors rounded-lg">
                  <div className="flex-1">
                    <div className="font-arabic text-lg" style={{color: '#D4700A'}}>فطور</div>
                    <div className="text-sm" style={{color: '#5D1A1A'}}>Breakfast</div>
                  </div>
                </button>
                <button onClick={() => scrollToSection('dining')} className="flex w-full text-left px-3 py-3 transition-colors rounded-lg">
                  <div className="flex-1">
                    <div className="font-arabic text-lg" style={{color: '#D4700A'}}>طعام</div>
                    <div className="text-sm" style={{color: '#5D1A1A'}}>Dining</div>
                  </div>
                </button>
                <button onClick={() => scrollToSection('gallery')} className="flex w-full text-left px-3 py-3 transition-colors rounded-lg">
                  <div className="flex-1">
                    <div className="font-arabic text-lg" style={{color: '#D4700A'}}>معرض</div>
                    <div className="text-sm" style={{color: '#5D1A1A'}}>Gallery</div>
                  </div>
                </button>
                <button onClick={() => scrollToSection('events')} className="flex w-full text-left px-3 py-3 transition-colors rounded-lg">
                  <div className="flex-1">
                    <div className="font-arabic text-lg" style={{color: '#D4700A'}}>مناسبات</div>
                    <div className="text-sm" style={{color: '#5D1A1A'}}>Events</div>
                  </div>
                </button>
                <button onClick={() => scrollToSection('catering')} className="flex w-full text-left px-3 py-3 transition-colors rounded-lg">
                  <div className="flex-1">
                    <div className="font-arabic text-lg" style={{color: '#D4700A'}}>خدمة</div>
                    <div className="text-sm" style={{color: '#5D1A1A'}}>Catering</div>
                  </div>
                </button>
                <button onClick={() => scrollToSection('contact')} className="flex w-full text-left px-3 py-3 transition-colors rounded-lg">
                  <div className="flex-1">
                    <div className="font-arabic text-lg" style={{color: '#D4700A'}}>اتصال</div>
                    <div className="text-sm" style={{color: '#5D1A1A'}}>Contact</div>
                  </div>
                </button>
                
                {/* Mobile CTA Button */}
                <div className="px-3 pt-3">
                  <button 
                    onClick={() => scrollToSection('contact')}
                    className="w-full py-3 rounded-lg font-bold text-white shadow-lg"
                    style={{background: 'linear-gradient(135deg, #5D1A1A, #D4700A)'}}
                  >
                    احجز الآن - Book Now
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://images.pexels.com/photos/6252726/pexels-photo-6252726.jpeg')`,
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
        </div>

        {/* Arabic Pattern Overlay */}
        <div 
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1657260745787-25e32c977056')`,
            backgroundSize: '150px 150px',
            backgroundRepeat: 'repeat'
          }}
        ></div>
        
        <div className="relative z-10 text-center text-white px-3 sm:px-4 max-w-6xl mx-auto">
          <h1 className="text-3xl xs:text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold mb-4 sm:mb-6 tracking-tight">
            <span className="block bg-gradient-to-r from-orange-400 to-red-400 bg-clip-text text-transparent">
              Byblos
            </span>
            <span className="block text-xl xs:text-2xl sm:text-3xl md:text-4xl lg:text-5xl mt-1 sm:mt-2 font-light">
              on O'Connell
            </span>
          </h1>
          <p className="text-sm sm:text-lg md:text-xl lg:text-2xl mb-4 sm:mb-6 lg:mb-8 max-w-3xl mx-auto leading-relaxed text-gray-200 px-2">
            Experience authentic Lebanese cuisine with oysters, pizza & pasta, plus risotto & other specialities in a refined eatery with a bar.
          </p>
          <p className="text-lg sm:text-xl lg:text-2xl mb-2 sm:mb-3 lg:mb-4 text-orange-300 font-arabic px-2">
            مطعم بيبلوس - نكهات لبنان الأصيلة
          </p>
          <p className="text-sm sm:text-base lg:text-lg mb-6 sm:mb-8 lg:mb-10 text-yellow-300 font-arabic px-2">
            أهلاً وسهلاً - مرحباً بكم في عالم الطعم اللبناني
          </p>
          <div className="flex flex-col xs:flex-row gap-3 sm:gap-4 justify-center px-2">
            <button 
              onClick={() => scrollToSection('breakfast')}
              className="px-4 sm:px-6 lg:px-8 py-3 sm:py-4 text-white font-bold text-sm sm:text-base lg:text-lg rounded-full transform hover:scale-105 transition-all duration-300 shadow-2xl"
              style={{background: 'linear-gradient(135deg, #5D1A1A, #D4700A)'}}
            >
              <span className="block xs:hidden">استكشف القائمة</span>
              <span className="hidden xs:block sm:hidden">Explore Menu</span>
              <span className="hidden sm:block">استكشف القائمة Explore Menu</span>
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="px-4 sm:px-6 lg:px-8 py-3 sm:py-4 bg-white/20 backdrop-blur-sm text-white font-bold text-sm sm:text-base lg:text-lg rounded-full hover:bg-white/30 transform hover:scale-105 transition-all duration-300 border border-white/30"
            >
              <span className="block xs:hidden">احجز طاولة</span>
              <span className="hidden xs:block sm:hidden">Reserve Table</span>
              <span className="hidden sm:block">احجز طاولة Reserve Table</span>
            </button>
          </div>
        </div>

        {/* Decorative Pattern */}
        <div className="absolute bottom-0 left-0 right-0 h-16 sm:h-32 bg-gradient-to-t from-amber-50 to-transparent"></div>
      </section>

      {/* Breakfast Section - Fairouz */}
      <section id="breakfast" className="py-12 sm:py-16 lg:py-20 relative overflow-hidden" style={{background: 'linear-gradient(135deg, #F5F0E8, #E8DCC6)'}}>
        {/* Background Pattern */}
        <div 
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage: `url('https://images.pexels.com/photos/31431958/pexels-photo-31431958.jpeg')`,
            backgroundSize: '200px 200px',
            backgroundRepeat: 'repeat'
          }}
        ></div>

        <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8 relative z-10">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold mb-3 sm:mb-4" style={{color: '#5D1A1A'}}>
              صباح الخير - Good Morning
            </h2>
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl font-arabic mb-3 sm:mb-4 px-2" style={{color: '#D4700A'}}>
              فيروز تغني لكم في الصباح
            </p>
            <p className="text-sm sm:text-base md:text-lg lg:text-xl max-w-3xl mx-auto px-4" style={{color: '#4A5D3A'}}>
              Start your day with authentic Lebanese breakfast featuring fresh ingredients and traditional flavors, inspired by the legendary Fairouz
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <div className="space-y-6 sm:space-y-8 order-2 lg:order-1">
              <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 sm:p-8 shadow-xl" style={{backgroundColor: 'rgba(245, 240, 232, 0.95)'}}>
                <h3 className="text-2xl sm:text-3xl font-bold mb-2" style={{color: '#5D1A1A'}}>Fairouz Special Breakfast</h3>
                <p className="text-base sm:text-lg font-arabic mb-4" style={{color: '#D4700A'}}>فطور فيروز الخاص</p>
                <ul className="space-y-2 sm:space-y-3 text-sm sm:text-base text-gray-700">
                  <li className="flex items-start">
                    <span className="w-2 h-2 rounded-full mr-3 mt-2 flex-shrink-0" style={{backgroundColor: '#5D1A1A'}}></span>
                    <span>Fresh Manakish with Za'atar & Cheese - مناقيش زعتر وجبنة</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 rounded-full mr-3 mt-2 flex-shrink-0" style={{backgroundColor: '#5D1A1A'}}></span>
                    <span>Lebanese Olives & Pickles - زيتون ومخللات لبنانية</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 rounded-full mr-3 mt-2 flex-shrink-0" style={{backgroundColor: '#5D1A1A'}}></span>
                    <span>Fresh Tomatoes & Cucumbers - بندورة وخيار طازج</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 rounded-full mr-3 mt-2 flex-shrink-0" style={{backgroundColor: '#5D1A1A'}}></span>
                    <span>Labneh with Olive Oil - لبنة بزيت الزيتون</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 rounded-full mr-3 mt-2 flex-shrink-0" style={{backgroundColor: '#5D1A1A'}}></span>
                    <span>Turkish Coffee or Lebanese Tea - قهوة تركية أو شاي لبناني</span>
                  </li>
                </ul>
              </div>
              
              <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 sm:p-8 shadow-xl" style={{backgroundColor: 'rgba(245, 240, 232, 0.95)'}}>
                <h3 className="text-xl sm:text-2xl font-bold mb-2" style={{color: '#D4700A'}}>Weekend Specials</h3>
                <p className="text-base sm:text-lg font-arabic mb-4" style={{color: '#5D1A1A'}}>عروض نهاية الأسبوع</p>
                <p className="text-sm sm:text-base text-gray-700 mb-4">
                  Join us for our famous weekend breakfast featuring Ful Medames, fresh bread, and traditional sweets.
                </p>
                <div className="font-bold text-sm sm:text-base" style={{color: '#5D1A1A'}}>
                  Available Saturdays & Sundays | 8:00 AM - 2:00 PM
                </div>
              </div>
            </div>

            <div className="relative order-1 lg:order-2">
              <div className="rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src="https://images.unsplash.com/photo-1635432877848-9c86755eb2f9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxMZWJhbmVzZSUyMGJyZWFrZmFzdHxlbnwwfHx8fDE3NTAzODk3MTl8MA&ixlib=rb-4.1.0&q=85"
                  alt="Lebanese Breakfast"
                  className="w-full h-64 sm:h-80 lg:h-96 object-cover"
                />
              </div>
              <div className="absolute -top-2 -right-2 sm:-top-4 sm:-right-4 w-16 h-16 sm:w-24 sm:h-24 bg-gradient-to-br from-orange-400 to-red-500 rounded-full flex items-center justify-center text-white font-bold text-sm sm:text-lg shadow-xl">
                <span className="font-arabic">فيروز</span>
              </div>
            </div>
          </div>

          {/* Fairouz Quote Section */}
          <div className="mt-12 sm:mt-16 text-center">
            <div className="bg-gradient-to-r from-red-600 to-orange-600 text-white rounded-2xl p-6 sm:p-8 max-w-4xl mx-auto shadow-2xl">
              <blockquote className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-arabic mb-3 sm:mb-4 px-2">
                "يا مسافر وصلك الصباح، والشمس عم تنده على كل مرتاح"
              </blockquote>
              <p className="text-sm sm:text-base lg:text-lg italic px-2">
                "O traveler, morning has reached you, and the sun is calling to everyone at rest"
              </p>
              <footer className="mt-3 sm:mt-4 text-orange-200 text-sm sm:text-base">
                - فيروز، أسطورة الغناء اللبناني
              </footer>
            </div>
          </div>
        </div>
      </section>

      {/* Lunch & Dinner Section */}
      <section id="dining" className="py-20 bg-gradient-to-br from-red-50 to-orange-50 relative overflow-hidden">
        {/* Background Pattern */}
        <div 
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1657260745787-25e32c977056')`,
            backgroundSize: '150px 150px',
            backgroundRepeat: 'repeat'
          }}
        ></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-5xl md:text-6xl font-bold text-gray-800 mb-4">
              Lunch & Dinner
            </h2>
            <p className="text-2xl text-red-600 font-arabic mb-4">
              غداء وعشاء - نكهات البحر المتوسط
            </p>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Discover our exquisite menu featuring Lebanese specialties, fresh oysters, artisanal pizzas, pasta, and risotto
            </p>
          </div>

          {/* Featured Dishes Carousel */}
          <div className="relative mb-16">
            <div className="overflow-hidden rounded-2xl shadow-2xl">
              <div 
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
              >
                {featuredDishes.map((dish, index) => (
                  <div key={index} className="w-full flex-shrink-0 relative">
                    <img 
                      src={dish.image}
                      alt={dish.title}
                      className="w-full h-96 object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end">
                      <div className="p-8 text-white">
                        <h3 className="text-3xl font-bold mb-2">{dish.title}</h3>
                        <p className="text-lg text-gray-200">{dish.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Carousel Indicators */}
            <div className="flex justify-center mt-4 space-x-2">
              {featuredDishes.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`w-3 h-3 rounded-full transition-colors ${
                    currentSlide === index ? 'bg-red-600' : 'bg-gray-300'
                  }`}
                />
              ))}
            </div>
          </div>

          {/* Menu Categories */}
          <div className="grid md:grid-cols-4 gap-8">
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-shadow">
              <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-orange-500 rounded-full flex items-center justify-center mb-6">
                <span className="text-white text-2xl">🥗</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-2">Mezze & Appetizers</h3>
              <p className="text-lg text-red-600 font-arabic mb-4">مزة ومقبلات</p>
              <p className="text-gray-600 mb-4">
                Traditional Lebanese mezze including hummus, tabbouleh, fattoush, and baba ganoush
              </p>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• Mixed Mezze Platter - مزة مشكلة</li>
                <li>• Kibbeh & Sambousek - كبة وسمبوسك</li>
                <li>• Fresh Salads - سلطات طازجة</li>
              </ul>
            </div>

            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-shadow">
              <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-orange-500 rounded-full flex items-center justify-center mb-6">
                <span className="text-white text-2xl">🦪</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-2">Fresh Oysters</h3>
              <p className="text-lg text-red-600 font-arabic mb-4">محار طازج</p>
              <p className="text-gray-600 mb-4">
                Premium fresh oysters sourced daily, served with traditional accompaniments
              </p>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• Fresh Daily Selection</li>
                <li>• Traditional Mignonette</li>
                <li>• Lebanese Style Preparation</li>
              </ul>
            </div>

            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-shadow">
              <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-orange-500 rounded-full flex items-center justify-center mb-6">
                <span className="text-white text-2xl">🍕</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-2">Pizza & Pasta</h3>
              <p className="text-lg text-red-600 font-arabic mb-4">بيتزا ومعكرونة</p>
              <p className="text-gray-600 mb-4">
                Artisanal pizzas and fresh pasta with Mediterranean and Lebanese influences
              </p>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• Wood-fired Pizza</li>
                <li>• Fresh Pasta & Risotto</li>
                <li>• Lebanese Fusion Style</li>
              </ul>
            </div>

            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-shadow">
              <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-orange-500 rounded-full flex items-center justify-center mb-6">
                <span className="text-white text-2xl">🍰</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-2">Desserts</h3>
              <p className="text-lg text-red-600 font-arabic mb-4">حلويات</p>
              <p className="text-gray-600 mb-4">
                Traditional Lebanese sweets and modern dessert creations
              </p>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• Baklava & Ma'amoul - بقلاوة ومعمول</li>
                <li>• Muhallabia - مهلبية</li>
                <li>• Knafeh Nabulsi - كنافة نابلسية</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="py-20 relative overflow-hidden" style={{background: 'linear-gradient(135deg, #E8DCC6, #F5F0E8)'}}>
        {/* Background Pattern */}
        <div 
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1657260745787-25e32c977056')`,
            backgroundSize: '150px 150px',
            backgroundRepeat: 'repeat'
          }}
        ></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-5xl lg:text-6xl font-bold mb-4" style={{color: '#5D1A1A'}}>
              Gallery - معرض الصور
            </h2>
            <p className="text-lg sm:text-2xl font-arabic mb-4" style={{color: '#D4700A'}}>
              طعام أصيل من مطبخنا
            </p>
            <p className="text-base sm:text-xl max-w-3xl mx-auto px-4" style={{color: '#4A5D3A'}}>
              Experience the authentic flavors and artistry of our Lebanese cuisine
            </p>
          </div>

          {/* Meet Our Chef Section */}
          <div className="mb-16">
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-8 shadow-2xl max-w-4xl mx-auto" style={{backgroundColor: 'rgba(245, 240, 232, 0.95)'}}>
              <div className="grid md:grid-cols-2 gap-8 items-center">
                <div className="relative">
                  <div className="w-full aspect-square bg-gradient-to-br from-gray-800 to-black rounded-2xl shadow-lg flex items-center justify-center overflow-hidden">
                    <img 
                      src={process.env.PUBLIC_URL + '/meet.jpg'}
                      alt="Chef Bilal"
                      className="object-cover w-full h-full object-center"
                    />
                  </div>
                </div>
                <div className="space-y-6">
                  <div>
                    <h3 className="text-3xl font-bold mb-2" style={{color: '#5D1A1A'}}>Chef Bilal</h3>
                    <p className="text-lg font-arabic mb-4" style={{color: '#D4700A'}}>
                      شيف بلال - خبير المطبخ اللبناني
                    </p>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    With over 15 years of experience in authentic Lebanese cuisine, Chef Bilal brings traditional flavors and modern techniques to every dish. 
                    Born in Beirut and trained in the finest Lebanese restaurants, he ensures every meal at Byblos reflects the true spirit of Lebanon.
                  </p>
                  <div className="space-y-2">
                    <div className="flex items-center">
                      <span className="w-2 h-2 rounded-full mr-3" style={{backgroundColor: '#D4700A'}}></span>
                      <span className="text-gray-700">15+ Years Lebanese Culinary Experience</span>
                    </div>
                    <div className="flex items-center">
                      <span className="w-2 h-2 rounded-full mr-3" style={{backgroundColor: '#D4700A'}}></span>
                      <span className="text-gray-700">Beirut Trained & Certified</span>
                    </div>
                    <div className="flex items-center">
                      <span className="w-2 h-2 rounded-full mr-3" style={{backgroundColor: '#D4700A'}}></span>
                      <span className="text-gray-700">Specializes in Traditional & Modern Lebanese</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Food Gallery Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
            {/* Manakish - Your uploaded image */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 hover:transform hover:scale-105" style={{backgroundColor: 'rgba(245, 240, 232, 0.95)'}}>
              <div className="relative">
                <img 
                  src={process.env.PUBLIC_URL + '/1.jpeg'}
                  alt="Authentic Lebanese Manakish with Za'atar"
                  className="w-full h-64 object-cover"
                />
                <div className="absolute top-4 right-4 px-3 py-1 rounded-full text-white text-sm font-bold" style={{backgroundColor: '#5D1A1A'}}>
                  Signature
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold mb-2" style={{color: '#5D1A1A'}}>Manakish Za'atar</h3>
                <p className="text-lg font-arabic mb-3" style={{color: '#D4700A'}}>مناقيش زعتر طازجة</p>
                <p className="text-gray-700 mb-4">
                  Freshly baked Lebanese flatbread topped with authentic za'atar blend, olive oil, and fresh vegetables. 
                  Served warm with Lebanese tea - a perfect start to your day.
                </p>
                <div className="flex justify-between items-center">
                  <span className="text-lg font-bold" style={{color: '#5D1A1A'}}>Available All Day</span>
                  <span className="text-sm" style={{color: '#D4700A'}}>🌟 Customer Favorite</span>
                </div>
              </div>
            </div>

            {/* Falafel & Dolmas */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 hover:transform hover:scale-105" style={{backgroundColor: 'rgba(245, 240, 232, 0.95)'}}>
              <div className="relative">
                <img 
                  src={process.env.PUBLIC_URL + '/2.jpeg'}
                  alt="Fresh Falafel with Traditional Sides"
                  className="w-full h-64 object-cover"
                />
                <div className="absolute top-4 right-4 px-3 py-1 rounded-full text-white text-sm font-bold" style={{backgroundColor: '#D4700A'}}>
                  Traditional
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold mb-2" style={{color: '#5D1A1A'}}>Falafel & Warak Enab</h3>
                <p className="text-lg font-arabic mb-3" style={{color: '#D4700A'}}>فلافل وورق عنب محشي</p>
                <p className="text-gray-700 mb-4">
                  Crispy homemade falafel served with stuffed grape leaves, fresh pickles, and tahini sauce. 
                  A classic Lebanese mezze combination that captures the essence of Middle Eastern flavors.
                </p>
                <div className="flex justify-between items-center">
                  <span className="text-lg font-bold" style={{color: '#5D1A1A'}}>Mezze Special</span>
                  <span className="text-sm" style={{color: '#D4700A'}}>🥬 Fresh Daily</span>
                </div>
              </div>
            </div>

            {/* Fatteh */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 hover:transform hover:scale-105" style={{backgroundColor: 'rgba(245, 240, 232, 0.95)'}}>
              <div className="relative">
                <img 
                  src={process.env.PUBLIC_URL + '/4.jpeg'}
                  alt="Traditional Lebanese Fatteh"
                  className="w-full h-64 object-cover"
                />
                <div className="absolute top-4 right-4 px-3 py-1 rounded-full text-white text-sm font-bold" style={{backgroundColor: '#4A5D3A'}}>
                  Chef's Special
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold mb-2" style={{color: '#5D1A1A'}}>Fatteh Djej</h3>
                <p className="text-lg font-arabic mb-3" style={{color: '#D4700A'}}>فتة الدجاج اللبنانية</p>
                <p className="text-gray-700 mb-4">
                  Layers of toasted pita bread, tender chicken, creamy yogurt, and aromatic spices. 
                  Topped with pine nuts and fresh herbs - a hearty Lebanese comfort food.
                </p>
                <div className="flex justify-between items-center">
                  <span className="text-lg font-bold" style={{color: '#5D1A1A'}}>Lunch Special</span>
                  <span className="text-sm" style={{color: '#D4700A'}}>🔥 Popular Choice</span>
                </div>
              </div>
            </div>

            {/* Mjadara */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 hover:transform hover:scale-105" style={{backgroundColor: 'rgba(245, 240, 232, 0.95)'}}>
              <div className="relative">
                <img 
                  src={process.env.PUBLIC_URL + '/3.jpeg'}
                  alt="Authentic Lebanese Mjadara"
                  className="w-full h-64 object-cover"
                />
                <div className="absolute top-4 right-4 px-3 py-1 rounded-full text-white text-sm font-bold" style={{backgroundColor: '#8B4513'}}>
                  Authentic
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold mb-2" style={{color: '#5D1A1A'}}>Mjadara</h3>
                <p className="text-lg font-arabic mb-3" style={{color: '#D4700A'}}>مجدرة بالبرغل والعدس</p>
                <p className="text-gray-700 mb-4">
                  Traditional Lebanese lentil and bulgur dish cooked with caramelized onions and warm spices. 
                  A nutritious and flavorful vegetarian option that represents authentic Lebanese home cooking.
                </p>
                <div className="flex justify-between items-center">
                  <span className="text-lg font-bold" style={{color: '#5D1A1A'}}>Vegetarian</span>
                  <span className="text-sm" style={{color: '#D4700A'}}>🌱 Healthy Choice</span>
                </div>
              </div>
            </div>
          </div>

          {/* Call to Action */}
          <div className="text-center mt-16">
            <div className="bg-gradient-to-r text-white rounded-2xl p-8 max-w-4xl mx-auto shadow-2xl" style={{background: 'linear-gradient(135deg, #5D1A1A, #D4700A)'}}>
              <h3 className="text-3xl font-bold mb-4">Experience These Flavors</h3>
              <p className="text-xl font-arabic mb-4">تذوقوا هذه النكهات الأصيلة</p>
              <p className="text-lg mb-6">
                Each dish is carefully prepared by Chef Bilal using traditional Lebanese recipes and the finest ingredients.
              </p>
              <button 
                onClick={() => scrollToSection('contact')}
                className="bg-white text-red-600 font-bold px-8 py-3 rounded-full hover:bg-gray-100 transition-colors shadow-lg"
              >
                Reserve Your Table - احجز طاولتك
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Events Section */}
      <section id="events" className="py-20 bg-gradient-to-br from-purple-50 to-red-50 relative overflow-hidden">
        {/* Background Pattern */}
        <div 
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage: `url('https://images.pexels.com/photos/31431958/pexels-photo-31431958.jpeg')`,
            backgroundSize: '250px 250px',
            backgroundRepeat: 'repeat'
          }}
        ></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-5xl md:text-6xl font-bold text-gray-800 mb-4">
              Special Events
            </h2>
            <p className="text-2xl text-purple-600 font-arabic mb-4">
              مناسبات خاصة - احتفالات لا تُنسى
            </p>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Create unforgettable memories with our special event hosting and celebration services in our refined eatery with private dining room
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
            <div className="space-y-8">
              <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-xl">
                <h3 className="text-3xl font-bold text-purple-600 mb-6">Functions & Specials</h3>
                <p className="text-lg text-red-600 font-arabic mb-6">وظائف ومناسبات خاصة</p>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center mr-4 mt-1">
                      <span className="text-white text-sm">🎉</span>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-800">Wedding Celebrations - أعراس</h4>
                      <p className="text-gray-600">Complete wedding packages with traditional Lebanese cuisine</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center mr-4 mt-1">
                      <span className="text-white text-sm">🎂</span>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-800">Birthday Parties - أعياد ميلاد</h4>
                      <p className="text-gray-600">Special birthday celebrations with customized menus</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center mr-4 mt-1">
                      <span className="text-white text-sm">🏢</span>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-800">Corporate Events - فعاليات تجارية</h4>
                      <p className="text-gray-600">Professional catering for business meetings and conferences</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center mr-4 mt-1">
                      <span className="text-white text-sm">🎊</span>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-800">Cultural Celebrations - احتفالات ثقافية</h4>
                      <p className="text-gray-600">Traditional Lebanese cultural events and festivals</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src={process.env.PUBLIC_URL + '/2.jpeg'}
                  alt="Lebanese Events"
                  className="w-full h-96 object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Catering Section */}
      <section id="catering" className="py-20 bg-gradient-to-br from-orange-50 to-red-50 relative overflow-hidden">
        {/* Background Pattern */}
        <div 
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1657260745787-25e32c977056')`,
            backgroundSize: '200px 200px',
            backgroundRepeat: 'repeat'
          }}
        ></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-5xl md:text-6xl font-bold text-gray-800 mb-4">
              Catering Services
            </h2>
            <p className="text-2xl text-orange-600 font-arabic mb-4">
              خدمات الطعام - فريق كامل للمناسبات
            </p>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Complete catering solutions with professional staff and entertainment services
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-xl text-center hover:transform hover:scale-105 transition-all">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl">👨‍🍳</span>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Professional Chefs</h3>
              <p className="text-sm text-red-600 font-arabic mb-2">طباخين محترفين</p>
              <p className="text-gray-600 text-sm">Expert Lebanese chefs for on-site cooking</p>
            </div>

            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-xl text-center hover:transform hover:scale-105 transition-all">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl">🍸</span>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Bartenders & Barmaids</h3>
              <p className="text-sm text-red-600 font-arabic mb-2">ساقي المشروبات</p>
              <p className="text-gray-600 text-sm">Professional beverage service specialists</p>
            </div>

            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-xl text-center hover:transform hover:scale-105 transition-all">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl">🎵</span>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Live Music</h3>
              <p className="text-sm text-red-600 font-arabic mb-2">موسيقى حية</p>
              <p className="text-gray-600 text-sm">Traditional Lebanese music and modern entertainment</p>
            </div>

            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-xl text-center hover:transform hover:scale-105 transition-all">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl">💃</span>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Belly Dancers</h3>
              <p className="text-sm text-red-600 font-arabic mb-2">راقصات شرقيات</p>
              <p className="text-gray-600 text-sm">Authentic Lebanese cultural entertainment</p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <div className="rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src={process.env.PUBLIC_URL + '/4.jpeg'}
                  alt="Lebanese Catering"
                  className="w-full h-96 object-cover"
                />
              </div>
            </div>

            <div className="space-y-8">
              <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-xl">
                <h3 className="text-3xl font-bold text-orange-600 mb-6">Complete Service Package</h3>
                <p className="text-lg text-red-600 font-arabic mb-6">حزمة خدمات كاملة</p>
                <div className="grid grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <h4 className="font-bold text-gray-800">Staff Services - خدمات الموظفين</h4>
                    <ul className="text-sm text-gray-600 space-y-1">
                      <li>• Waiters & Waitresses - نادلين ونادلات</li>
                      <li>• Bartenders & Barmaids - ساقي مشروبات</li>
                      <li>• Professional Chefs - طباخين محترفين</li>
                    </ul>
                  </div>
                  <div className="space-y-2">
                    <h4 className="font-bold text-gray-800">Entertainment - ترفيه</h4>
                    <ul className="text-sm text-gray-600 space-y-1">
                      <li>• Live Music - موسيقى حية</li>
                      <li>• Belly Dancers - راقصات شرقيات</li>
                      <li>• Cultural Shows - عروض ثقافية</li>
                    </ul>
                  </div>
                  <div className="space-y-2">
                    <h4 className="font-bold text-gray-800">Documentation - توثيق</h4>
                    <ul className="text-sm text-gray-600 space-y-1">
                      <li>• Professional Photography - تصوير احترافي</li>
                      <li>• Video Coverage - تصوير فيديو</li>
                      <li>• Event Documentation - توثيق المناسبة</li>
                    </ul>
                  </div>
                  <div className="space-y-2">
                    <h4 className="font-bold text-gray-800">Setup & Decoration - تجهيز وزينة</h4>
                    <ul className="text-sm text-gray-600 space-y-1">
                      <li>• Event Decoration - زينة المناسبة</li>
                      <li>• Table Setup - ترتيب الطاولات</li>
                      <li>• Venue Styling - تنسيق المكان</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-r from-red-600 to-orange-600 text-white rounded-2xl p-8 shadow-xl">
                <h3 className="text-2xl font-bold mb-4">Get a Custom Quote</h3>
                <p className="text-lg font-arabic mb-4">احصل على عرض سعر مخصص</p>
                <p className="mb-6">
                  Contact us for personalized catering packages tailored to your event needs and budget.
                </p>
                <button className="bg-white text-red-600 font-bold px-6 py-3 rounded-full hover:bg-gray-100 transition-colors">
                  Request Quote - طلب عرض سعر
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-12 sm:py-16 lg:py-20 bg-gradient-to-br from-gray-800 to-red-900 text-white relative overflow-hidden">
        {/* Background Pattern */}
        <div 
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1657260745787-25e32c977056')`,
            backgroundSize: '100px 100px',
            backgroundRepeat: 'repeat'
          }}
        ></div>

        <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8 relative z-10">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-3 sm:mb-4">
              Visit Us Today
            </h2>
            <p className="text-lg sm:text-xl lg:text-2xl text-orange-300 font-arabic mb-3 sm:mb-4 px-2">
              زورونا اليوم - تجربة لا تُنسى
            </p>
            <p className="text-base sm:text-lg lg:text-xl text-gray-300 max-w-3xl mx-auto px-4">
              Experience authentic Lebanese cuisine in our refined eatery with outdoor seating, private dining room, and full bar
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 sm:p-8 shadow-xl">
              <h3 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6">Contact Information</h3>
              <p className="text-base sm:text-lg text-orange-300 font-arabic mb-4 sm:mb-6">معلومات الاتصال</p>
              <div className="space-y-3 sm:space-y-4">
                <div className="flex items-start">
                  <span className="text-orange-400 mr-3 text-lg">📍</span>
                  <div className="flex-1">
                    <h4 className="font-bold text-sm sm:text-base">Address - العنوان</h4>
                    <p className="text-gray-300 text-sm sm:text-base leading-relaxed">21/23 O'Connell St<br/>North Adelaide SA 5006</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <span className="text-orange-400 mr-3 text-lg">📞</span>
                  <div className="flex-1">
                    <h4 className="font-bold text-sm sm:text-base">Phone - الهاتف</h4>
                    <p className="text-gray-300 text-sm sm:text-base">+61 (08) 8267 4822</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <span className="text-orange-400 mr-3 text-lg">✉️</span>
                  <div className="flex-1">
                    <h4 className="font-bold text-sm sm:text-base">Email - البريد الإلكتروني</h4>
                    <p className="text-gray-300 text-sm sm:text-base break-all">info@byblosonconnell.com.au</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <span className="text-orange-400 mr-3 text-lg">🌐</span>
                  <div className="flex-1">
                    <h4 className="font-bold text-sm sm:text-base">Website</h4>
                    <p className="text-gray-300 text-sm sm:text-base break-all">byblosoconnell.com.au</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 sm:p-8 shadow-xl">
              <h3 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6">Opening Hours</h3>
              <p className="text-base sm:text-lg text-orange-300 font-arabic mb-4 sm:mb-6">ساعات العمل</p>
              <div className="space-y-2 sm:space-y-3">
                <div className="flex flex-col sm:flex-row sm:justify-between gap-1">
                  <span className="text-sm sm:text-base">Monday - Tuesday</span>
                  <span className="text-orange-400 text-sm sm:text-base">11:30 AM - 12:00 AM</span>
                </div>
                <div className="flex flex-col sm:flex-row sm:justify-between gap-1">
                  <span className="text-sm sm:text-base">Wednesday - Thursday</span>
                  <span className="text-orange-400 text-sm sm:text-base">8:00 AM - 12:00 AM</span>
                </div>
                <div className="flex flex-col sm:flex-row sm:justify-between gap-1">
                  <span className="text-sm sm:text-base">Friday - Saturday</span>
                  <span className="text-orange-400 text-sm sm:text-base">8:00 AM - 2:00 AM</span>
                </div>
                <div className="flex flex-col sm:flex-row sm:justify-between gap-1">
                  <span className="text-sm sm:text-base">Sunday</span>
                  <span className="text-orange-400 text-sm sm:text-base">8:00 AM - 12:00 AM</span>
                </div>
              </div>
              <div className="mt-4 sm:mt-6 p-3 sm:p-4 bg-orange-600/20 rounded-lg">
                <p className="text-xs sm:text-sm text-orange-300">
                  <strong>Features - المميزات:</strong>
                </p>
                <ul className="text-xs sm:text-sm text-orange-200 mt-2 space-y-1">
                  <li>• Has all you can eat - بوفيه مفتوح</li>
                  <li>• Has outdoor seating - جلسات خارجية</li>
                  <li>• Has private dining room - غرفة طعام خاصة</li>
                </ul>
              </div>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 sm:p-8 shadow-xl">
              <h3 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6">Reserve a Table</h3>
              <p className="text-base sm:text-lg text-orange-300 font-arabic mb-4 sm:mb-6">احجز طاولة</p>
              <form className="space-y-3 sm:space-y-4">
                <input 
                  type="text" 
                  placeholder="Your Name - اسمك"
                  className="w-full px-3 sm:px-4 py-2 sm:py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-orange-400 text-sm sm:text-base"
                />
                <input 
                  type="email" 
                  placeholder="Email Address - البريد الإلكتروني"
                  className="w-full px-3 sm:px-4 py-2 sm:py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-orange-400 text-sm sm:text-base"
                />
                <input 
                  type="tel" 
                  placeholder="Phone Number - رقم الهاتف"
                  className="w-full px-3 sm:px-4 py-2 sm:py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-orange-400 text-sm sm:text-base"
                />
                <textarea 
                  placeholder="Special Requests - طلبات خاصة"
                  rows="3"
                  className="w-full px-3 sm:px-4 py-2 sm:py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-orange-400 text-sm sm:text-base resize-none"
                ></textarea>
                <button 
                  type="submit"
                  className="w-full bg-gradient-to-r from-orange-500 to-red-500 text-white font-bold py-2 sm:py-3 rounded-lg hover:from-orange-600 hover:to-red-600 transition-all text-sm sm:text-base"
                >
                  Make Reservation - احجز الآن
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
             
              <div className="relative z-10 text-center flex items-center justify-center">
                    <img 
                      src={process.env.PUBLIC_URL + '/logo.png'} 
                      alt="Byblos Logo" 
                      className="h-12 sm:h-16 w-auto mx-auto"
                      style={{ borderRadius: '10px' }}

                    />
                  </div> 
              <p className="text-gray-400 mb-4 text-sm sm:text-base">
                Authentic Lebanese cuisine with fresh oysters, artisanal pizzas, pasta, and risotto in the heart of North Adelaide.
              </p>
              <p className="text-orange-400 font-arabic text-sm sm:text-base">
                مطعم بيبلوس - نكهات البحر المتوسط في أديلايد
              </p>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-4">Quick Links - روابط سريعة</h4>
              <ul className="space-y-2 text-gray-400">
                <li><button onClick={() => scrollToSection('breakfast')} className="hover:text-orange-400 transition-colors">Breakfast - فطور</button></li>
                <li><button onClick={() => scrollToSection('dining')} className="hover:text-orange-400 transition-colors">Lunch & Dinner - غداء وعشاء</button></li>
                <li><button onClick={() => scrollToSection('gallery')} className="hover:text-orange-400 transition-colors">Gallery - معرض</button></li>
                <li><button onClick={() => scrollToSection('events')} className="hover:text-orange-400 transition-colors">Events - مناسبات</button></li>
                <li><button onClick={() => scrollToSection('catering')} className="hover:text-orange-400 transition-colors">Catering - خدمة طعام</button></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-4">Specialties - التخصصات</h4>
              <ul className="space-y-2 text-gray-400">
                <li>Fresh Oysters - محار طازج</li>
                <li>Lebanese Mezze - مزة لبنانية</li>
                <li>Wood-fired Pizza - بيتزا فرن حطب</li>
                <li>Fresh Pasta & Risotto - معكرونة ورزوتو</li>
                <li>Private Dining - طعام خاص</li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-4">Follow Us - تابعونا</h4>
              <div className="text-gray-400 mb-4">
                <p className="font-arabic">شاركونا على مواقع التواصل الاجتماعي</p>
              </div>
              <div className="flex space-x-4">
                <button className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors">
                  <span className="text-white">f</span>
                </button>
                <button className="w-10 h-10 bg-pink-600 rounded-full flex items-center justify-center hover:bg-pink-700 transition-colors">
                  <span className="text-white">📷</span>
                </button>
                <button className="w-10 h-10 bg-blue-400 rounded-full flex items-center justify-center hover:bg-blue-500 transition-colors">
                  <span className="text-white">🐦</span>
                </button>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2025 Byblos on O'Connell. All rights reserved.</p>
            <p className="mt-2 font-arabic">جميع الحقوق محفوظة - مطعم بيبلوس</p>
            <p className="mt-2">Bringing authentic Lebanese & Mediterranean flavors to North Adelaide</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;